<template>
  <div id="app" class="footer-page">
    <BaseLayout v-if="!isMobile">
      <div class="footer tw-w-full tw-flex tw-flex-col">
        <div
          class="tw-grid md:tw-grid-cols-3 lg:tw-grid-cols-7 tw-text-center tw-gap-3 tw-w-full tw-py-12"
        >
          <!-- 社区部分 -->
          <div class="tw-w-full">
            <h4 class="mb-3">{{ $t("社区") }}</h4>
            <ul class="list-unstyled">
              <li class="mb-2">
                <a
                  :href="footObj?.contact?.telegramLink"
                  target="_blank"
                  style="line-height: 1.8"
                >
                  <div
                    class="tw-w-full d-flex align-items-center tw-justify-center text-dark"
                  >
                    <div class="tw-w-8">
                      <img
                        src="@/static/icon-telegram.png"
                        alt=""
                        style="width: 18px; height: 18px"
                      />
                    </div>

                    <span class="ml-1 tw-w-16 tw-text-left">Telegram</span>
                  </div>
                </a>
              </li>
              <li class="mb-2">
                <a
                  :href="footObj?.contact?.youtubeLink"
                  target="_blank"
                  style="line-height: 1.8"
                >
                  <div
                    class="d-flex align-items-center tw-justify-center text-dark"
                  >
                    <div class="tw-w-8">
                      <img
                        src="@/static/icon-youtube.png"
                        alt=""
                        style="width: 18px; height: 18px"
                      />
                    </div>
                    <span class="ml-1 tw-w-16 tw-text-left">You Tube</span>
                  </div>
                </a>
              </li>
              <li class="mb-2">
                <a
                  :href="footObj?.contact?.tiktokLink"
                  target="_blank"
                  style="line-height: 1.8"
                >
                  <div
                    class="d-flex align-items-center tw-justify-center text-dark"
                  >
                    <div class="tw-w-8">
                      <img
                        src="@/static/icon-tiktok.png"
                        alt=""
                        style="width: 18px; height: 18px"
                      />
                    </div>
                    <span class="ml-1 tw-w-16 tw-text-left">Tik Tok</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>

          <!-- 热门产品部分 -->
          <div class="tw-w-full">
            <h4 class="mb-3">{{ $t("热门产品") }}</h4>
            <ul class="list-unstyled">
              <template v-if="footObj && footObj.recommendProductList">
                <li
                  class="mb-2 list-underline"
                  v-for="(item, index) in footObj.recommendProductList[0]
                    .products"
                  :key="item.id"
                  @click="
                    handleClickRouter({
                      path: '/product/' + item.id + '?isApi=false',
                      pathName: '/product',
                      ...item,
                    })
                  "
                >
                  <span
                    v-if="index < 3"
                    href="#"
                    class="text-decoration-none text-dark"
                    >{{ $t(item.name) }}</span
                  >
                </li>
              </template>
            </ul>
          </div>

          <!-- 关于天晟部分 -->
          <div class="tw-w-full">
            <h4 class="mb-3">{{ $t("关于天晟") }}</h4>
            <ul class="list-unstyled">
              <li class="mb-2 list-underline">
                <span
                  href=""
                  class="text-decoration-none text-dark"
                  @click="handleClickRouter({ path: '/company' })"
                  >{{ $t("了解天晟") }}</span
                >
              </li>
              <li class="mb-2 list-underline">
                <span
                  href=""
                  class="text-decoration-none text-dark"
                  @click="handleClickRouter({ path: '/dynamics' })"
                  >{{ $t("最新动态") }}</span
                >
              </li>
              <li class="mb-2 list-underline">
                <span
                  href=""
                  class="text-decoration-none text-dark"
                  @click="handleClickRouter({ path: '/contact' })"
                  >{{ $t("联系我们") }}</span
                >
              </li>
            </ul>
          </div>

          <!-- 地址和电话部分 -->
          <div class="tw-w-full">
            <h4 class="mb-3">{{ $t("地址") }}</h4>
            <ul class="list-unstyled">
              <li
                v-for="(
                  address, index
                ) in footObj?.contact?.companyAddress?.split('\n')"
                :key="index"
                class="mb-2"
              >
                <span class="text-dark">{{ $t(address) }}</span>
              </li>
            </ul>
          </div>

          <!-- 联系方式部分 -->
          <div class="tw-w-full">
            <h4 class="mb-3">{{ $t("联系方式") }}</h4>
            <ul class="list-unstyled">
              <li class="mb-2">
                <span class="text-dark"
                  >{{ $t("邮箱") }}：{{ footObj?.contact?.email }}</span
                >
              </li>
              <li class="mb-2">
                <span class="text-dark"
                  >{{ $t("微信") }}：{{ footObj?.contact?.wechat }}</span
                >
              </li>
              <li class="mb-2 list-underline">
                <a
                  href=" https://t.me/Skysp_Web3"
                  target="_blank"
                  style="line-height: 1.8"
                >
                  <span class="text-dark"
                    >{{ $t("TG号") }}：{{ footObj?.contact?.tg }}</span
                  >
                </a>
              </li>
            </ul>
          </div>

          <!-- 文档部分 -->
          <div class="tw-w-full">
            <h4 class="mb-3">{{ $t("文档") }}</h4>
            <ul class="list-unstyled">
              <template v-if="footObj && footObj.docList">
                <li
                  class="mb-2 list-underline"
                  v-for="(item, index) in footObj.docList"
                  :key="item.id"
                  @click="
                    handleClickRouter({
                      path: '/document',
                      ...item,
                    })
                  "
                >
                  <span
                    v-if="index < 3"
                    href="#"
                    class="text-decoration-none text-dark"
                    >{{ $t(item.name) }}</span
                  >
                </li>
              </template>
            </ul>
          </div>

          <div class="tw-w-full">
            <h4 class="mb-3">{{ $t("热线电话") }}</h4>
            <ul class="list-unstyled">
              <li class="mt-3">
                <span class="text-dark">{{
                  $t(footObj?.contact?.preSalePhone)
                }}</span>
              </li>
              <li class="mt-2">
                <span class="text-dark">{{
                  $t(footObj?.contact?.afterSalePhone)
                }}</span>
              </li>
              <li class="mt-2">
                <span class="text-dark">{{
                  $t(footObj?.contact?.servicePhone)
                }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="copyright tw-py-5 tw-border-t">
          <div class="container text-center text-md-start">
            <p class="mb-1 text-muted small">
              Copyright © <span>{{ footObj?.contact?.domain }}</span> , All
              Rights Reserved.
            </p>
            <p class="mb-0 text-muted small">
              {{ $t("专业的区块链开发团队") }}
              <span class="tw-ml-2">{{ footObj?.contact?.icpNumber }}</span>
            </p>
          </div>
        </div>
      </div>
    </BaseLayout>
    <!-- h5 -->
    <div v-else>
      <div class="footer-content">
        <h4 class="mb-3 foot-hot">{{ $t("常用入口") }}</h4>
        <ul class="list-unstyled product-list">
          <li class="mb-2 footer-list-item" @click="$router.push('/product')">
            {{ $t("热门产品") }}
          </li>
          <li class="mb-2 footer-list-item" @click="$router.push('/solution')">
            {{ $t("解决方案") }}
          </li>
          <li class="mb-2 footer-list-item" @click="$router.push('/contact')">
            {{ $t("联系我们") }}
          </li>
        </ul>
      </div>

      <div class="footer-content">
        <h4 class="mb-3 foot-hot">{{ $t("关注我们") }}</h4>
        <ul class="list-unstyled list-center">
          <li class="mb-2">
            <a
              href="https://t.me/TSWeb3"
              target="_blank"
              style="line-height: 1.8"
            >
              <div class="d-flex align-items-center text-dark">
                <img
                  src="@/static/icon-telegram.png"
                  alt=""
                  style="width: 18px; height: 18px"
                />
                <span class="ml-1 tw-text-xs">Telegram</span>
              </div>
            </a>
          </li>
          <li class="mb-2">
            <a
              href="https://youtube.com/channel/UCZRuaXDIUkJ1RwU1r8nMr3w"
              target="_blank"
              style="line-height: 1.8"
            >
              <div class="d-flex align-items-center text-dark">
                <img
                  src="@/static/icon-youtube.png"
                  alt=""
                  style="width: 18px; height: 18px"
                />
                <span class="ml-1 tw-text-xs">You Tube</span>
              </div>
            </a>
          </li>
          <li class="mb-2">
            <a
              href="https://v.douyin.com/JgG-hDF--u0/"
              target="_blank"
              style="line-height: 1.8"
            >
              <div class="d-flex align-items-center text-dark">
                <img
                  src="@/static/icon-tiktok.png"
                  alt=""
                  style="width: 18px; height: 18px"
                />
                <span class="ml-1 tw-text-xs">Tik Tok</span>
              </div>
            </a>
          </li>
        </ul>
      </div>

      <div class="footer-phone">
        <div class="phone-icon">
          {{ $t("热线电话") }}
          <span>：{{ $t("15601382371") }}</span>
        </div>
      </div>
      <div class="copyright py-3">
        <div class="container text-center text-md-start">
          <p class="mb-1 tw-text-xs">
            Copyright © https://skyshinetech.com , All Rights Reserved.
          </p>
          <p class="mb-0 tw-text-xs">
            {{ $t("专业的区块链开发团队") }}
            <span class="tw-ml-2">辽ICP备2023001457号-3</span>
          </p>
        </div>
      </div>
    </div>

    <!--    <footer class="footer bg-light py-5">-->
    <!--      <div>-->
    <!--        <div class="row tw-w-full">-->
    <!--          &lt;!&ndash; 社区部分 &ndash;&gt;-->
    <!--          <div class="col-lg-2 col-md-6 mb-4 mb-lg-0">-->
    <!--            <h4 class=" mb-3">{{ $t('社区') }}</h4>-->
    <!--            <ul class="list-unstyled">-->
    <!--              <li class="mb-2">-->
    <!--                <a href="https://t.me/TSWeb3" target="_blank" style="line-height:1.8;">-->
    <!--                  <div class="d-flex align-items-center  text-dark">-->
    <!--                    <img src="@/static/icon-telegram.png" alt="" style="width: 18px;height: 18px;">-->
    <!--                    <span class="ml-1">Telegram</span>-->
    <!--                  </div>-->
    <!--                </a>-->
    <!--              </li>-->
    <!--              <li class="mb-2">-->
    <!--                <a href="https://youtube.com/channel/UCZRuaXDIUkJ1RwU1r8nMr3w" target="_blank" style="line-height:1.8;">-->
    <!--                  <div class="d-flex align-items-center  text-dark">-->
    <!--                    <img src="@/static/icon-youtube.png" alt="" style="width: 18px;height: 18px;">-->
    <!--                    <span class="ml-1">You Tube</span>-->
    <!--                  </div>-->
    <!--                </a>-->
    <!--              </li>-->
    <!--              <li class="mb-2">-->
    <!--                <a href="https://v.douyin.com/JgG-hDF&#45;&#45;u0/" target="_blank" style="line-height:1.8;">-->
    <!--                  <div class="d-flex align-items-center  text-dark">-->
    <!--                    <img src="@/static/icon-tiktok.png" alt="" style="width: 18px;height: 18px;">-->
    <!--                    <span class="ml-1">Tik Tok</span>-->
    <!--                  </div>-->
    <!--                </a>-->
    <!--              </li>-->
    <!--            </ul>-->
    <!--          </div>-->

    <!--          &lt;!&ndash; 热门产品部分 &ndash;&gt;-->
    <!--          <div class="col-lg-1 col-md-6 mb-4 mb-lg-0" style="min-width: 150px;margin-left: -60px;">-->
    <!--            <h4 class=" mb-3">{{ $t('热门产品') }}</h4>-->
    <!--            <ul class="list-unstyled">-->
    <!--              <template v-if="footObj && footObj.recommendProductList">-->
    <!--                <li class="mb-2" v-for="(item, index) in footObj.recommendProductList[0].products"-->
    <!--                    :key="item.id" @click="handleClickRouter({-->
    <!--                                                  path: '/product/' + item.id + '?isApi=false',-->
    <!--                                                  pathName: '/product', ...item-->
    <!--                                              })">-->
    <!--                                              <span v-if="index < 3" href="#" class="text-decoration-none text-dark">{{-->
    <!--                                                  item.name-->
    <!--                                                }}</span>-->
    <!--                </li>-->
    <!--              </template>-->
    <!--            </ul>-->
    <!--          </div>-->

    <!--          &lt;!&ndash; 关于天晟部分 &ndash;&gt;-->
    <!--          <div class="col-lg-1 col-md-6 mb-4 mb-lg-0" style="min-width: 150px;">-->
    <!--            <h4 class=" mb-3">{{ $t('关于天晟') }}</h4>-->
    <!--            <ul class="list-unstyled">-->
    <!--              <li class="mb-2">-->
    <!--                                          <span href="" class="text-decoration-none text-dark"-->
    <!--                                                @click="handleClickRouter({ path: '/company' })">{{-->
    <!--                                              $t('了解天晟')-->
    <!--                                            }}</span>-->
    <!--              </li>-->
    <!--              <li class="mb-2">-->
    <!--                                          <span href="" class="text-decoration-none text-dark"-->
    <!--                                                @click="handleClickRouter({ path: '/dynamics' })">{{-->
    <!--                                              $t('最新动态')-->
    <!--                                            }}</span>-->
    <!--              </li>-->
    <!--              <li class="mb-2">-->
    <!--                                          <span href="" class="text-decoration-none text-dark"-->
    <!--                                                @click="handleClickRouter({ path: '/contact' })">{{-->
    <!--                                              $t('联系我们')-->
    <!--                                            }}</span>-->
    <!--              </li>-->
    <!--            </ul>-->
    <!--          </div>-->

    <!--          &lt;!&ndash; 文档部分 &ndash;&gt;-->
    <!--          <div class="col-lg-1 col-md-6 mb-4 mb-lg-0" style="min-width: 130px;">-->
    <!--            <h4 class=" mb-3">{{ $t('文档') }}</h4>-->
    <!--            <ul class="list-unstyled">-->
    <!--              <template v-if="footObj && footObj.docList">-->
    <!--                <li class="mb-2" v-for="(item, index) in footObj.docList" :key="item.id" @click="handleClickRouter({-->
    <!--                                              path: '/document',-->
    <!--                                              ...item-->
    <!--                                          })">-->
    <!--                                              <span v-if="index < 3" href="#" class="text-decoration-none text-dark">{{-->
    <!--                                                  item.name-->
    <!--                                                }}</span>-->
    <!--                </li>-->
    <!--              </template>-->
    <!--            </ul>-->
    <!--          </div>-->

    <!--          &lt;!&ndash; 联系方式部分 &ndash;&gt;-->
    <!--          <div class="col-lg-2 col-md-6 mb-4 mb-lg-0">-->
    <!--            <h4 class=" mb-3">{{ $t('联系方式') }}</h4>-->
    <!--            <ul class="list-unstyled">-->
    <!--              <li class="mb-2">-->
    <!--                <span class="text-dark">{{ $t('邮箱') }}：Windir@qq.com</span>-->
    <!--              </li>-->
    <!--              <li class="mb-2">-->
    <!--                <span class="text-dark">{{ $t('微信游戏') }}：BF-GameFi</span>-->
    <!--              </li>-->
    <!--            </ul>-->
    <!--          </div>-->

    <!--          &lt;!&ndash; 地址和电话部分 &ndash;&gt;-->
    <!--          <div class="col-lg-2 col-md-6">-->
    <!--            <h4 class=" mb-3">{{ $t('地址') }}</h4>-->
    <!--            <ul class="list-unstyled">-->
    <!--              <li class="mb-2">-->
    <!--                <span class="text-dark">{{ $t('广州天河区国翔科汇城') }}</span>-->
    <!--              </li>-->
    <!--              <li class="mb-2">-->
    <!--                <span class="text-dark">{{ $t('沈阳沈河区金利大厦') }}</span>-->
    <!--              </li>-->
    <!--              <li class="mb-2">-->
    <!--                <span class="text-dark">{{ $t('北京朝阳区青年路4号和院文创园') }}</span>-->
    <!--              </li>-->
    <!--            </ul>-->
    <!--          </div>-->
    <!--          <div class="col-lg-2 col-md-6">-->
    <!--            <h4 class=" mb-3">{{ $t('热线电话') }}</h4>-->
    <!--            <ul class="list-unstyled">-->
    <!--              <li class="mt-3">-->
    <!--                <span class="text-dark">400-0000-0000</span>-->
    <!--              </li>-->
    <!--            </ul>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </footer>-->
  </div>
</template>

<script>
import BaseLayout from "@/layout/BaseLayout.vue";

export default {
  components: { BaseLayout },
  data() {
    return {
      setInt: null,
      footObj: {},
      isMobile: false, //默认pc视图
    };
  },
  mounted() {
    this.setInt = setInterval(() => {
      this.checkCacheAndUpdateKey();
    }, 1000);
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleClickRouter(row) {
      if (this.$route.path == row.path || this.$route.path == row.pathName)
        return;
      if (row.id) {
        localStorage.setItem("detailForm", JSON.stringify(row));
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
      // 如果是文档类型，需要传递id参数
      if (row.path === "/document" && row.id) {
        this.$router.push({
          path: row.path,
          query: {
            categoryId: row.id,
          },
        });
      } else {
        this.$router.push({ path: row.path });
      }
    },
    checkCacheAndUpdateKey() {
      const indexInfo = localStorage.getItem("indexInfo");
      const documentCategories = localStorage.getItem("documentCategories");

      if (!indexInfo || !documentCategories) return;

      try {
        const info = JSON.parse(indexInfo);
        const docList = JSON.parse(documentCategories);

        if (info && docList) {
          this.footObj = {
            ...info,
            docList,
          };
          clearInterval(this.setInt);
          this.setInt = null;
        }
      } catch (error) {
        console.error("JSON parse error:", error);
      }
    },

    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  background: #f8f8f8;
  // margin-top: 54px;
}

.footer {
  // padding-left: 40px;

  a {
    color: #666;

    &:hover {
      color: #333;
      text-decoration: underline;
    }
  }

  h4 {
    color: #333;
    font-weight: 500;
  }
}

.copyright {
  p {
    margin-bottom: 0;
  }
}

.text-dark {
  cursor: pointer;
  font-size: 13px;
}

@media (max-width: 992px) {
  .footer {
    padding: 30px 0;
  }
}

@media screen and (min-width: 1200px) {
  .footer {
    width: 1500px;
    margin: 0 auto;
  }
}

@media screen and (max-width: 1199px) and (min-width: 1000px) {
  .footer {
    width: 1000px;
    margin: 0 auto;
  }
}

.mb-3 {
  font-size: 18px;
}
.footer-content {
  padding: 0 20px;
  box-sizing: border-box;
  &:first-child {
    padding: 20px;
  }
}
.foot-hot {
  text-align: center;
  font-size: 14px;
}
.product-list {
  display: flex;
  justify-content: center;
  gap: 25px;
  border-bottom: 1px solid #e5e5e5;
}

.footer-list-item {
  font-size: 12px;
  cursor: pointer;
  &:hover {
    color: #333;
    text-decoration: underline;
  }
}

.list-center {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.footer-phone {
  padding: 10px;
  text-align: center;
  font-size: 16px;
  border-radius: 20px;
  border: 1px solid #e5e5e5;
  margin: 20px;
}

.list-underline {
  &:hover {
    text-decoration: underline;
  }
}
</style>
